import { add, multiply, roundToThreeDecimals } from "../../../utils/mathUtils";

/**
 * Calculate total quantity for a spec
 * Adds base quantity, attic stock, and overage quantity with 3 decimal precision
 * @param {number} baseQuantity - Base quantity
 * @param {number} atticStock - Attic stock quantity
 * @param {number} overageQuantity - Overage quantity
 * @returns {number} Total quantity rounded to 3 decimal places
 */
export const calculateTotalQuantity = (
  baseQuantity,
  atticStock,
  overageQuantity
) => {
  const total = add(baseQuantity || 0, atticStock || 0, overageQuantity || 0);
  return roundToThreeDecimals(total);
};

/**
 * Calculate overage quantity based on percentage
 * Applies overage percent to sum of base quantity and attic stock
 * @param {number} overagePercent - Overage percentage (e.g., 0.1 for 10%)
 * @param {number} baseQuantity - Base quantity
 * @param {number} atticStock - Attic stock quantity
 * @returns {number} Overage quantity rounded to 3 decimal places
 */
export const calculateOverageQuantity = (
  overagePercent,
  baseQuantity,
  atticStock
) => {
  const overageQuantity = multiply(
    overagePercent,
    add(baseQuantity || 0, atticStock || 0)
  );
  return roundToThreeDecimals(overageQuantity);
};
